<template>
  <ClientOnly>
    <Hero />
  </ClientOnly>

  <ClientOnly>
    <NuxtErrorBoundary>
      <NuxtPage />
    </NuxtErrorBoundary>
  </ClientOnly>
  <!-- <slot /> -->
  <TheFooter />
</template>
